export const PRODUCTS_KEYWORD_TRANSLATIONS: Record<string, string> = {
	en: 'products',
	de: 'produkte',
	fr: 'produits',
	it: 'prodotti'
};
